import { useEffect } from 'react';
import { gridActions } from '../../../actions';
import { constants } from '../../../constants';
import { useAppDispatch } from '../../../effects/useAppDispatch';
import { Grid } from '../../grid';
import { SectionContent } from '../../amrPipeline/common/section/SectionContent';
import { GridColumn } from '../../../types/state/GridState';
import { SyndicateContact } from '../../../types/loan/Loan';

interface DealContactsSectionProps {
    initialContacts: SyndicateContact[];
}

const dealContactsColumns: GridColumn[] = [{
        name: 'firstName',
        title: 'First Name',
        length: 64,
        required: false,
        initialValue: '',
        pattern: constants.contactsName,
    }, {
        name: 'lastName',
        title: 'Last Name',
        length: 64,
        required: false,
        initialValue: '',
        pattern: constants.contactsName,
    }, {
        name: 'desk',
        title: 'Desk',
        length: 64,
        required: false,
        initialValue: '',
        pattern: constants.nonWhitespace,
    }, {
        name: 'linkedIn',
        title: 'LinkedIn',
        length: 256,
        required: false,
        initialValue: '',
        pattern: constants.nonWhitespace,
    }, {
        name: 'title',
        title: 'Title',
        length: 256,
        required: false,
        initialValue: '',
        pattern: constants.nonWhitespace,
    }, {
        name: 'email',
        title: 'Email',
        length: 256,
        required: false,
        initialValue: '',
        unique: true,
        pattern: /^[a-zA-Z0-9.!#$%&' * +/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    }, {
        name: 'officePhone',
        title: 'Office',
        length: 32,
        required: false,
        initialValue: '',
        pattern: constants.nonWhitespace,
    }, {
        name: 'mobilePhone',
        title: 'Mobile',
        length: 32,
        required: false,
        initialValue: '',
        pattern: constants.nonWhitespace,
    },
];

export function DealContactsSection({ initialContacts }: DealContactsSectionProps) {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(gridActions.reset());
        dispatch(
            gridActions.init(
                initialContacts,
                dealContactsColumns,
                constants.gridRowsLimit,
                10,
                false,
            ),
        );

        return () => {
            dispatch(gridActions.reset());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return (
        <SectionContent title="Deal Contacts" className="loan-deal-contacts-section">
            <Grid dataUploadDisabled />
        </SectionContent>
    );
}
